module.exports = __webpack_public_path__ + "static/media/3DPPA35.bf390a7a.jpg";